module.exports = __webpack_public_path__ + "img/huatai.aef221a0.png";